<template>
  <div class="search-box">
    <form @submit.prevent="doSearch">
      <div class="label-input">
        <label for="searchName" v-show="searchName === ''">{{ namePlaceholder }}</label>
        <input
          type="text"
          id="searchName"
          name="searchName"
          v-model="searchName"
          :aria-placeholder="namePlaceholder"
          @keydown.13.prevent="doSearch"
          @keyup="searchKeyUp"
        />
      </div>
      <div class="label-input">
        <label for="searchId" v-show="searchId === '' && currentTab !== 'subGroup'">{{ idPlaceholder }}</label>
        <input
          type="text"
          id="searchId"
          name="searchId"
          v-model="searchId"
          :aria-placeholder="idPlaceholder"
          v-show="currentTab !== 'subGroup'"
          @keydown.13.prevent="doSearch"
        >
      </div>
      <async-button
        v-if="searchVisible"
        type="submit"
        class="btn --sm search-button"
        :executing="searching"
        @clicked="doSearch"
        :disabled="searchDisabled"
      >
        Search
      </async-button>
    </form>
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api';
import { useStore } from '@vue3shims';
import AsyncButton from '@molecules/AsyncButton.vue';
import { useGroupSelector } from '@composables/useGroupSelector';
export default {
  setup() {
    const store = useStore();
    const { group, parentGroup, currentTab, searching, updateFilter } = useGroupSelector();
    // const currentTab = computed(() => store.getters['groupSelector/currentTab']);
    const idPlaceholder = computed(() => {
      switch (currentTab.value) {
        case 'parentGroup':
          return 'Parent Group ID';
        case 'group':
          return 'Group ID';
        case 'subGroup':
          return 'SubGroup ID';
      }
    });
    const isInternalUser = computed(() => store.getters['isInternalUser']);
    const namePlaceholder = computed(() => {
      switch (currentTab.value) {
        case 'parentGroup':
          return 'Parent Group Name';
        case 'group':
          return 'Group Name';
        case 'subGroup':
          return 'SubGroup Name';
      }
    });
    const searchId = computed({
      get() {
        return store.getters['groupSelector/searchId'];
      },
      set(newVal) {
        store.commit('groupSelector/SET_SEARCH_ID', newVal);
      }
    });
    const searchName = computed({
      get() {
        return store.getters['groupSelector/searchName'];
      },
      set(newVal) {
        store.commit('groupSelector/SET_SEARCH_NAME', newVal);
      }
    });
    // const searching = computed(() => store.getters['groupSelector/searching']);
    const searchDisabled = computed(() => {
      switch (currentTab.value) {
        case 'parentGroup':
          return false;
        case 'group': 
          return false;
        case 'subGroup':
          return parentGroup.value === null && group.value === null;
      }
    });
    const searchVisible = computed(() => {
      return currentTab.value !== 'subGroup';
    });
    const doSearch = async () => {
      if(!isInternalUser.value) {
        return;
      }
      if (!(searchId.value === '' && searchName.value === '')) {
        const opts = {
          id: searchId.value,
          name: searchName.value,
        }
        switch (currentTab.value) {
          case 'group':
            await store.dispatch('groupSelector/SEARCH_GROUPS', opts);
            break;
          case 'parentGroup':
            opts.isParentGroupSearch = true;
            await store.dispatch('groupSelector/SEARCH_PARENT_GROUPS', opts);
            break;
        }
      }
    }
  
    const searchKeyUp = (_) => {
      updateFilter({id: searchId.value, name: searchName.value});
    }

    return {
      currentTab,
      doSearch,
      idPlaceholder,
      namePlaceholder,
      searchId,
      searching,
      searchDisabled,
      searchKeyUp,
      searchName,
      searchVisible,
    }

  },
  components: {
    AsyncButton,
  }
}
</script>

<style lang="scss" scoped>
.search-box {
  background-color: $color-light-gray-alt;
  color: $black;
  width: 100%;
  padding-bottom: .3rem;
  form {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-evenly;
    min-height: 2rem;
    width: 100%;

    .label-input {
      min-height: 2.2rem;
      position: relative;
      min-width: 44%;
      max-width: 100%;
      flex: 1 0 auto;
      label {
        top: 0;
        position: absolute;
        z-index: 10;
        padding-left: 1rem;
      }
      input {
        position: absolute;
        top: 0;
        left: 0;
      }
    }

    #searchId,
    #searchName {
      border: 1px solid $color-border;

      &::placeholder {
        color: $color-search-text;
      }
    }

    .search-button {
      border: 1px solid $leaf;
      padding: 10px 25px;
    }
  }
}
</style>
